import {ItemType} from '../../../api/memex-items/item-type'
import type {MemexItemModel} from '../../../models/memex-item-model'
import type {Cell, Row} from './types'

/**
 * @deprecated - Use `row.getIsExpanded()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const rowIsExpanded = (row: Row<MemexItemModel>) => {
  return row.getIsExpanded()
}

/**
 * @deprecated - Use `row.getIsGrouped()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const rowIsGrouped = (row: Row<MemexItemModel>) => {
  return row.getIsGrouped()
}

/**
 * @deprecated - Use `row.getIsSelected()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const rowIsSelected = (row: Row<MemexItemModel>) => {
  return row.getIsSelected()
}

/**
 * @deprecated - Use `row.toggleSelected(value)` directly.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const rowToggleSelected = (row: Row<MemexItemModel>, value?: boolean) => {
  row.toggleSelected(value)
}

/**
 * @deprecated - Use `row.getCanSelect()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const rowGetCanSelect = (row: Row<MemexItemModel>) => {
  return row.getCanSelect()
}

/**
 * @deprecated - Use `row.getVisibleCells()` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const getVisibleCells = (row: Row<MemexItemModel>): Array<Cell<MemexItemModel>> => {
  return row.getVisibleCells()
}

export const getFirstVisibleCell = (row: Row<MemexItemModel>): Cell<MemexItemModel> | undefined => {
  return row.getCenterVisibleCells()[0]
}

export const isNonRedactedRow = (row: Row<MemexItemModel> | undefined): row is Row<MemexItemModel> => {
  return !!(row && row.original.contentType !== ItemType.RedactedItem)
}

/**
 * @deprecated - Use `row.groupingColumnId` instead.
 * This function was introduced to ease the migration to TanStack Table v8,
 * and is no longer necessary.
 */
export const groupingColumnId = (row: Row<MemexItemModel>): string | undefined => {
  return row.groupingColumnId
}
